module.exports = __webpack_public_path__ + "img/loginbg.43ac541e.png";